<div class="sidenav-sm">
  <mat-toolbar class="fixed-top w-100">
    {{'COMMON.LABEL.MENU' | translate}}
  </mat-toolbar>

  <div class="sidebar-content">
    <div *ngFor="let item of navigationMenu; let index = index"
      class="item"
      [ngClass]="{'router-link-active': linkActive.isActive}"
      [routerLink]="item.routerLink"
      routerLinkActive
      #linkActive="routerLinkActive"
      (click)="closeSidenav()">
      <mat-icon class="mx-3"
        [color]="linkActive.isActive ? 'accent' : 'primary'">{{item.icon}}</mat-icon>
      {{item.title | translate}}
    </div>
  </div>

  <mat-toolbar class="fixed-bottom justify-content-start w-100">
    <span class="mat-caption">
      v{{appVersion}} - {{appBuildAt | date}}
    </span>
    <span class="flex-grow-1"></span>
    <div>
      <bitf-mat-language-selector></bitf-mat-language-selector>
    </div>
  </mat-toolbar>
</div>